import React, { useEffect, useRef, useState } from "react";
import { DropDown, TextInput } from "./styles";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import {
  getDocumentType,
  getPayerMasterPatient,
  uploadDocumentPatient,
} from "apiHandler/actions";

const DocumentHeader = ({
  practiceId,
  token,
  patientId,
  userName,
  fetchData,
}) => {
  const [docType, setDocType] = useState(null);
  const [payer, setPayer] = useState(null);
  const [title, setTitle] = useState("");
  const [claimSub, setClaimSub] = useState(false);
  const [des, setDes] = useState("");
  const [searchText, setSearchText] = useState("");
  const [docTypes, setDocTypes] = useState([]);
  const [payers, setPayers] = useState([]);
  const [uploading, setUploading] = useState(false);

  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    console.log("selectedFile: ", selectedFile);
    if (selectedFile) {
      onUploadFile(selectedFile);
    }
  };

  useEffect(() => {
    getDocumentsType();
  }, []);

  useEffect(() => {
    if (searchText === "") return;

    const handler = setTimeout(() => {
      getPayers();
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);

  const getDocumentsType = async () => {
    try {
      const payload = {
        type: "DocumentType",
        practice_id: practiceId,
      };
      const res = await getDocumentType(payload, token);
      if (res) {
        const updatedData = res.map((item) => {
          return {
            label: item.document_type,
            id: item.id,
          };
        });

        setDocTypes(updatedData);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const getPayers = async () => {
    try {
      const payload = {
        type: "Payer",
        practice_id: practiceId,
        search_by: searchText,
      };

      const res = await getPayerMasterPatient(payload, token);
      if (res) {
        setPayers(res);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const onUploadFile = async (file) => {
    setUploading(true);
    try {
      const payload = {
        type: "Documents",
        practice_id: practiceId,
        patient_id: patientId,
        include_claim: claimSub,
      };
      if (docType && docType.id) {
        payload["document_type_id"] = docType.id;
        payload.document_type = docType.label;
      }
      if (payer && payer.payer_id) {
        payload.payor_id = payer.payer_id;
      }
      if (title !== "") {
        payload.filetitle = title;
      }
      if (des !== "") {
        payload.filedescription = des;
      }
      const data = new FormData();
      data.append("file", file);
      console.log("File before appending:", file);

      data.append(
        "request_json",
        JSON.stringify({
          ...payload,
          user_name: userName,
          practice_id: practiceId,
        })
      );

      for (let pair of data.entries()) {
        console.log(pair[0], pair[1]);
      }
      await uploadDocumentPatient(data, token);
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setUploading(false);
      fetchData();
    }
  };

  return (
    <Box>
      <Box mb={2} mt={1} display="flex" alignItems="center" gap={2}>
        <DropDown
          disablePortal
          options={docTypes}
          size="small"
          value={docType}
          onChange={(_, newValue) => {
            setDocType(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Document Type"
              size="small"
              variant="standard"
            />
          )}
        />
        <DropDown
          disablePortal
          options={payers}
          size="small"
          value={payer}
          onChange={(_, newValue) => {
            setPayer(newValue);
          }}
          getOptionLabel={(values) =>
            `${values.payer_id} - ${values.payer_name}`
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Payer"
              size="small"
              variant="standard"
              onChange={(e) => setSearchText(e.target.value)}
            />
          )}
        />
        <TextInput
          value={title}
          label="Title"
          onChange={(e) => setTitle(e.target.value)}
          size="small"
          variant="standard"
        />
        <TextInput
          value={des}
          label="Description"
          onChange={(e) => setDes(e.target.value)}
          size="small"
          variant="standard"
        />
      </Box>
      <Box mb={2} mt={1} display="flex" alignItems="center" gap={2}>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              value={claimSub}
              onClick={() => setClaimSub(!claimSub)}
            />
          }
          label="Do you want to include it as part of claim submission"
        />
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
          accept={claimSub ? ".pdf" : ".png,.jpg,.tiff,.jpeg,.pdf"}
        />
        <Button
          disabled={uploading}
          variant="outlined"
          size="small"
          onClick={handleButtonClick}
        >
          Choose A File And Upload
        </Button>
      </Box>
    </Box>
  );
};

export default DocumentHeader;
